/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terminal_LoadingInputs */

const en_terminal_loading = /** @type {(inputs: Terminal_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading...`)
};

const ar_terminal_loading = /** @type {(inputs: Terminal_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ التحميل...`)
};

const bn_terminal_loading = /** @type {(inputs: Terminal_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লোড হচ্ছে...`)
};

const de_terminal_loading = /** @type {(inputs: Terminal_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird geladen …`)
};

const es_terminal_loading = /** @type {(inputs: Terminal_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando...`)
};

const fr_terminal_loading = /** @type {(inputs: Terminal_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement...`)
};

const pt_terminal_loading = /** @type {(inputs: Terminal_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando...`)
};

const zh_terminal_loading = /** @type {(inputs: Terminal_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载中...`)
};

const tr_terminal_loading = /** @type {(inputs: Terminal_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yükleniyor...`)
};

const ru_terminal_loading = /** @type {(inputs: Terminal_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка...`)
};

const pl_terminal_loading = /** @type {(inputs: Terminal_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ładowanie...`)
};

/**
* | output |
* | --- |
* | "Loading..." |
*
* @param {Terminal_LoadingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const terminal_loading = /** @type {((inputs?: Terminal_LoadingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terminal_LoadingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_terminal_loading(inputs)
	if (locale === "bn") return bn_terminal_loading(inputs)
	if (locale === "de") return de_terminal_loading(inputs)
	if (locale === "es") return es_terminal_loading(inputs)
	if (locale === "fr") return fr_terminal_loading(inputs)
	if (locale === "pt") return pt_terminal_loading(inputs)
	if (locale === "zh") return zh_terminal_loading(inputs)
	if (locale === "tr") return tr_terminal_loading(inputs)
	if (locale === "ru") return ru_terminal_loading(inputs)
	if (locale === "pl") return pl_terminal_loading(inputs)
	return en_terminal_loading(inputs)
});